import * as React from "react";
const SvgJourneyClick = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2.4, strokeLinejoin: "round", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 4.5l12 6.3-5.1 1.65L11.1 18z" }));
export default SvgJourneyClick;
